export default "__VITE_ASSET__qEcCVM$2__"